<template>
  <div>
    <b-row>
      <b-col cols="12">
        <vue-bootstrap4-table
          ref="table"
          :actions="actions_"
          :classes="classes"
          :clickable="clickable"
          :columns="columns_"
          :config="config_"
          :delete_icon="delete_icon"
          :enable-drag="enableDrag"
          :filter-in-mounted="filterInMounted"
          :mapping-ellipsis="mappingEllipsis"
          :no-header="noHeader"
          :rows="rows"
          :small-table="smallTable"
          :sticky_="sticky_"
          :total-rows="total_rows"
          @clicked="clicked"
          @delete-selected="trigger('delete-selected')"
          @left-selected="$emit('left-selected', $event)"
          @on-access="trigger('on-access')"
          @on-add="trigger('on-add')"
          @on-add-wizard="trigger('on-add-wizard')"
          @on-all-select-rows="selected"
          @on-all-unselect-rows="selected"
          @on-change-query="onChangeQuery"
          @on-checkbox="checkbox"
          @on-clear="trigger('on-clear')"
          @on-edit="trigger('on-edit')"
          @on-enable="trigger('on-enable')"
          @on-export="trigger('on-export')"
          @on-export-admin="trigger('on-export-admin')"
          @on-export-pdf="trigger('on-export-pdf')"
          @on-filter="trigger('on-filter')"
          @on-filters-open="trigger('on-filters-open')"
          @on-import="trigger('on-import')"
          @on-import-xls="trigger('on-import-xls')"
          @on-import-zip="trigger('on-import-zip')"
          @on-invite="trigger('on-invite')"
          @on-recompute="$emit('on-recompute')"
          @on-refresh="refresh()"
          @on-remind="trigger('on-remind')"
          @on-report="trigger('on-report')"
          @on-return="trigger('on-return')"
          @on-save="trigger('on-save')"
          @on-select-row="selected"
          @on-show-modal="trigger('on-show-modal')"
          @on-show-warning="$emit('on-show-warning')"
          @on-sync="trigger('on-sync')"
          @on-toggle="toggle"
          @on-unselect-row="unselected"
          @per_page_update="perPageUpdate"
          @refresh-data="trigger('on-refresh')"
          @reorder="reorder"
          @row_hover="row_hover"
          @row_hover_out="row_hover_out"
          @row_out="row_out"
          @row_over="row_over"
          @selected="$emit('selected', $event)"
          @update:length="$emit('update:length', $event)"
        >
          <template
            v-if="!loading"
            #empty-results
          >
            {{ custom_no_results ? custom_no_results : _('No data') }}
          </template>
          <template #sort-asc-icon> <span class="sort">&#x2191;</span><span class="no-sort" /> </template>
          <template #sort-desc-icon> <span class="no-sort" /><span class="sort">&#x2193;</span> </template>
          <template #no-sort-icon>
            <span class="no-sort">&#x2191;</span>
          </template>
          <template #refresh-button-text>
            <i class="far fa-refresh" />
          </template>
          <template #reset-button-text>
            <translate>Reset filters</translate>
          </template>
          <template
            v-if="delete_icon"
            #multi_edit
          >
            <IconAction
              class="mt-2 fix-trash"
              color="danger"
              icon="trash"
              @click="$emit('delete-selected')"
            />
          </template>
          <template
            v-if="loading"
            #spin-loading
          >
            <div
              class="text-center"
              style="width: 100px; height: 100px; display: block; margin: auto"
            >
              <i
                class="far text-primary text-center fa-circle-notch fa-2x fa-spin"
                style="display: block; margin: auto"
              />
            </div>
          </template>

          <!-- Pass on all named slots -->
          <slot
            v-for="slot in Object.keys($slots)"
            :slot="slot"
            :name="slot"
          />

          <!-- Pass on all scoped slots -->
          <template
            v-for="slotName in Object.keys($scopedSlots)"
            #[slotName]="scope"
          >
            <slot
              :name="slotName"
              v-bind="scope"
            />
          </template>
        </vue-bootstrap4-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueBootstrap4Table from '@/components/ui/fork-bootstrap4-table/src/components/VueBootstrap4Table.vue'
import IconAction from '@/components/ui/IconAction.vue'
import { copyNestedObjects } from '@/helpers/Object.helpers'

export default {
  name: 'AcisoTable',
  components: {
    IconAction,
    VueBootstrap4Table,
  },
  props: {
    rows: Array,
    enableDrag: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    noHeader: {
      type: Boolean,
      default: false,
    },
    filterInMounted: {
      type: Boolean,
      default: true,
    },
    total_rows: Number,
    config: Object,
    classes: Object,
    actions: Array,
    smallTable: {
      type: Boolean,
      default: false,
    },
    delete_icon: {
      type: Boolean,
      default: false,
    },
    mappingEllipsis: {
      type: Boolean,
      default: false,
    },
    custom_no_results: {
      type: String,
      default: null,
    },
    filter_btn: Object,
    columns: Array,
    'no-header': {
      type: Boolean,
      default: false,
    },
    sticky_: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      hover_item: null,
      do_show_refresh: false,
      total_new_rows: 0,
      selected_items: [],
    }
  },
  computed: {
    columns_: function () {
      const res = []
      this.columns.forEach((c) => {
        const c2 = copyNestedObjects(c)
        if (!c2.row_text_alignment) {
          c2.row_text_alignment = 'text-left'
        }
        if (!c2.column_text_alignment) {
          c2.column_text_alignment = 'text-left'
        }
        res.push(c2)
      })
      return res
    },
    config_() {
      const _this = this
      const config_ = copyNestedObjects(this.config)
      if (config_.rows_selectable) {
        config_.highlight_row_hover_color = '#2C526308'
      }
      if (config_.show_refresh_button) {
        config_.show_refresh_button = false
        _this.do_show_refresh = true
      }

      return config_
    },
    actions_() {
      let actions_ = copyNestedObjects(this.actions)
      if (!actions_) {
        actions_ = []
      }
      if (this.do_show_refresh) {
        if (this.filter_btn) {
          actions_.push(this.filter_btn)
        }
      }
      return actions_
    },
  },
  mounted: function () {
    this.$refs.table.$refs.global_search = { value: '' }
  },
  methods: {
    setSelectedRow(row) {
      this.$refs.table.setSelectedRow(row)
    },
    perPageUpdate(per_page) {
      this.$log.debug('PER PAGE UPDATE !!!', per_page)
      this.$store.commit('per_page', per_page)
    },
    onChangeQuery: function (q) {
      this.$emit('changeQuery', q)
    },
    trigger: function (event_name) {
      this.$emit(event_name)
    },
    selected: function (obj) {
      this.selected_items = obj.selected_items
      this.$emit('selected', obj.selected_items)
    },
    reorder: function (obj) {
      this.$emit('reorder', obj)
    },
    toggle: function (obj) {
      this.$emit(obj.event_name, obj.value)
    },
    checkbox: function (obj) {
      this.$log.debug('EVENT1', obj)
      this.$emit(obj.event_name, obj.value)
    },
    clicked: function (obj) {
      this.$emit('clicked', obj.id, obj.type)
      this.$emit('clicked_row', obj)
      this.$emit('clicked_simple', obj)
    },
    row_out: function (obj) {
      this.$emit('row_out', obj.id)
    },
    row_over: function (obj) {
      this.$emit('row_over', obj.id)
    },
    row_hover_out: function () {
      this.$emit('row_hover_out')
    },
    row_hover: function (obj) {
      this.$emit('row_hover', obj.order)
    },
    unselected: function (obj) {
      this.selected_items = obj.selected_items
      this.$emit('selected', obj.selected_items)
    },
    refresh() {
      this.$refs.table.allRowsSelected = false
      this.$refs.table.unSelectAllItems()
      this.$refs.table.selected_items = []
      this.selected_items = []
      this.$emit('selected', [])
      this.trigger('on-refresh')
    },
  },
}
</script>

<style lang="scss" scoped>
.list-group-item {
  cursor: pointer;
}

.list-group-item-draggable i {
  cursor: pointer;
}

.list-group-item-draggable {
  cursor: move;
}

.list-group-item-draggable i {
  cursor: pointer;
}

.icon-todo-remove {
  color: grey;
}

.list-group-item-draggable {
  cursor: move;
}

.list-group-item-draggable i {
  cursor: pointer;
}

.hover-todo:hover {
  background-color: #f5f5f5;
}
</style>
